import React from "react";
import { Flex } from "antd";
import Header from "../components/Header/Header";
import MyText from "../../components/UI/Text/MyText";
import Footer from "../components/Footer/Footer";
import { Link } from "react-router-dom";

const PolicyPage = () => {
  return (
    <Flex
      style={{ width: "100%", position: "relative" }}
      vertical
      align={"center"}
      justify={"flex-start"}
    >
      <Header />
      <Flex
        style={{
          width: "100%",
          paddingTop: 250,
          position: "relative",
          overflow: "hidden",
          paddingBottom: 50,
        }}
        vertical
        align={"center"}
        justify={"flex-start"}
      >
        <Flex
          style={{ width: "100%", maxWidth: 1440, position: "relative" }}
          vertical
          gap={35}
          align={"center"}
          justify={"flex-start"}
        >
          <MyText style={{ fontSize: "2rem", fontWeight: "bold" }}>
            Нууцлалын Бодлого
          </MyText>
          <Flex
            style={{ width: "100%", position: "relative", maxWidth: 700 }}
            align={"center"}
            justify={"center"}
            vertical
            gap={30}
          >
            <Link
              target={"_blank"}
              to={"https://disk.yandex.kz/d/22q7Qp_gVXgR6w"}
            >
              <MyText>Datenschutzerklärung BO-App</MyText>
            </Link>
            <Link
              target={"_blank"}
              to={"https://disk.yandex.kz/d/22q7Qp_gVXgR6w"}
            >
              <MyText>Informationspflichten für Teilnehmende</MyText>
            </Link>
            <Link
              target={"_blank"}
              to={"https://disk.yandex.kz/d/22q7Qp_gVXgR6w"}
            >
              <MyText>Impressum App BO</MyText>
            </Link>
            <MyText>
              Mit dem Versenden des Kontaktformulars willige ich in die
              Verarbeitung meiner oben angegebenen Daten für die FAV-Plattform
              zur Beruflichen Information ein. Ich habe die
              Informationspflichten gelesen und zur Kenntnis genommen.*
            </MyText>
          </Flex>
        </Flex>
      </Flex>
      <Footer />
    </Flex>
  );
};

export default PolicyPage;
